module.exports = __webpack_public_path__ + "img/logo.8973b3de.png";